import React, {FC} from 'react';

import {SettingsPreferencesUrl} from '../../models/url/settingsUrlModel';
import {SettingsPanelId} from '../../store/panels/panelStateBase';
import {SettingsPreferences} from './settingsPreferences';

interface SettingsPreferencesContainerProps {
  panelId: SettingsPanelId;
  url: SettingsPreferencesUrl;
}

export const SettingsPreferencesContainer: FC<SettingsPreferencesContainerProps> = (props) => (
  <SettingsPreferences {...props} />
);
